import App from './app.js';
import router from './router';
import events from './events';

import * as collections from './collections';
import * as dialogs from './dialogs';
import * as models from './models';
import * as panels from './panels';
import * as views from './views';

export {
    App,
    router,
    events,
    collections,
    dialogs,
    models,
    panels,
    views
};



// WEBPACK FOOTER //
// ./~/@girder/histomicsui/index.js